import React, { useState } from 'react';
import ImageUploader from './index';
import S3FileManager from './delete';
import './s3handler.css';
import { Box, Typography, Button } from "@material-ui/core"; // Added for UI consistency
import { Link } from "react-router-dom";

const S3Portal = ({ isAuth, a_imageupload }) => {
  const [activeTab, setActiveTab] = useState('upload'); 

  return (
    <div className="s3-portal-root">
      {a_imageupload ? (
        <div className="s3-portal-container">
          <div className="portal-nav">
            <button 
              className={`nav-btn ${activeTab === 'upload' ? 'active' : ''}`}
              onClick={() => setActiveTab('upload')}
            >
              📤 Upload Image
            </button>
            <button 
              className={`nav-btn ${activeTab === 'library' ? 'active' : ''}`}
              onClick={() => setActiveTab('library')}
            >
              📂 S3 Library / Delete
            </button>
          </div>

          <div className="portal-content">
            {activeTab === 'upload' ? (
              <ImageUploader onNavigate={() => setActiveTab('library')} />
            ) : (
              <S3FileManager />
            )}
          </div>
        </div>
      ) : (
              <Box>
                <Typography>You are not allowed</Typography>
                <Link to="/" style={{ textDecoration: "none" }}>
                  <Button>Go back</Button>
                </Link>
              </Box>
            )}
    </div>
  );
};

export default S3Portal;